import { loadSentry } from './sentry';
import { loadLogRocket } from './logrocket';
import { loadHelpScout } from './helpscout';

export function loadThirdParty() {
  loadLogRocket();
  loadSentry();
  loadHelpScout();
}
